'use strict';

module.exports = {
    input: require('../directives/input'),
    select: require('../directives/select')
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/mixins/directives.js
// module id = 1346
// module chunks = 0